import { useDeleteAllFromBasketMutation } from 'autogen/swagger/all/hooks';
import { ButtonWithSpinner } from 'components/Button';
import { updateBasket } from 'components/basket/shared/basket';

export default function DeleteAllButton() {
    const { mutateAsync } = useDeleteAllFromBasketMutation({ onSuccess: updateBasket });

    return (
        <ButtonWithSpinner size="sm" onClick={() => mutateAsync({})}>
            Tøm kurv
        </ButtonWithSpinner>
    );
}
